<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-cloud-computing`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M16 24a1 1 0 01-1-1v-2a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-1 1h-6v8.342A6.017 6.017 0 0129.66 36h6.876a4 4 0 110 4.001h-6.877a6.002 6.002 0 01-11.316 0h-6.878a4 4 0 110-4.001h6.877a6.016 6.016 0 013.66-3.659L22 24h-6zm8 12a2 2 0 100 4 2 2 0 000-4zm0-32c5.984 0 11.12 3.902 12.753 9.357C41.422 14.04 45 17.93 45 22.625 45 27.803 40.651 32 35.286 32H31v-4h4.213c3.086 0 5.587-2.417 5.587-5.399s-2.501-5.399-5.587-5.399c-.047 0-.093 0-.14.002l-1.771.042-.284-1.69C32.291 11.215 28.48 8 24 8s-8.29 3.216-9.018 7.555l-.284 1.69-1.771-.041a5.895 5.895 0 00-.14-.002c-3.086 0-5.587 2.417-5.587 5.4C7.2 25.581 9.701 28 12.787 28H18v4h-6.27v-.047C6.827 31.477 3 27.483 3 22.625c0-4.696 3.578-8.585 8.247-9.268C12.879 7.902 18.017 4 24 4z"/></svg>
</template>
<script>

export default {
  name: 'IconCloudComputing',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
